import React, { Fragment, Suspense, useMemo, useState } from 'react';
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { DataProvider, RequestErrors } from '@ai4/data-request';
import { Props as DataProviderProps } from '@ai4/data-request/dist/components/DataContext';
import { loggedIn, loggedOut } from 'src/@bootstrap/features/auth';
import ErrorCatcher from 'src/@bootstrap/components/alert/ErrorCatcher';

type Props = Partial<DataProviderProps>;

function Data(props: Props) {
    const [boot, setBoot] = useState<boolean>();
    const [errors, setErrors] = useState<RequestErrors>();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const APIBase = useMemo(() => ({
        onContinueSession: (tokens) => {
            setBoot(true);
            if (tokens) {
                dispatch(loggedIn({
                    role: 'SA'
                }));
            }
        },
        onInvalidAccess: () => {
            dispatch(loggedOut());
            navigate("/session/signin", {
                state: { redirectUrl: location.pathname }
            });
        },
        onErrors: (errors: RequestErrors) => {
			setErrors(errors);
        },
        ...props,
    }), []);

    return (
        <DataProvider {...APIBase as DataProviderProps}>
            <Fragment>
            {!!errors && <ErrorCatcher
				errors={(errors || []).map(e => ({
					...e,
					message: (e.messages || []).join(' - ')
				}))}
                hideMessages
				onClose={() => {
					setErrors(undefined);
				}}
			/>}
            {boot && props.children as any}
            </Fragment>
        </DataProvider>
    );
}

export default Data;
